import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageGuard, PageType } from 'src/app/core/services/page-guard.service';
import { PeopleComponent } from './people.component';

const routes: Routes = [
    {
        path: '',
        component: PeopleComponent,
        canActivate: [PageGuard],
        data: { Page: PageType.People }
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PeopleRoutingModule { }
